import React, { useState } from 'react';
import SortButton from '../../UI/SortButton';

const FeedbackReportsTableHeader = () => {

  const [sortedBy, setSortedBy] = useState({
    created: null,
    name: null,
    email: null,
    subject: null,
    replied_by: null,
  });

  return (
    <tr>
      <SortButton 
        name="Date"
        sortBy="created"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Name"
        sortBy="name"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Email"
        sortBy="email"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Subject"
        sortBy="subject"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <SortButton 
        name="Status"
        sortBy="replied_by"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <th>
        Actions
      </th>
    </tr>
  )
}

export default FeedbackReportsTableHeader;